import React, { useId } from 'react'
import styles from './empty.module.scss'

/**
 * Ilustrasi empty state bergaya halaman login: biru lembut, folder + dokumen
 * mengambang + kaca pembesar melayang. Animasi halus (amplitudo kecil, durasi
 * panjang) lewat class dari empty.module.scss, hormati prefers-reduced-motion.
 */
const EmptyIllustration = ({ className }) => {
  // ID gradient wajib unik per instance — kalau di-hardcode, saat ilustrasi
  // dirender lebih dari sekali di halaman, `url(#id)` bentrok dan folder hilang.
  const uid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const frontId = `empty-folder-front-${uid}`
  const backId = `empty-folder-back-${uid}`

  return (
    <svg
      className={className}
      viewBox="0 0 240 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={frontId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#5b8cf7" />
          <stop offset="1" stopColor="#4678f3" />
        </linearGradient>
        <linearGradient id={backId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#8fb0fb" />
          <stop offset="1" stopColor="#6c98f8" />
        </linearGradient>
      </defs>

      {/* alas lembut */}
      <ellipse cx="120" cy="120" rx="104" ry="66" fill="#eef3fe" />
      <ellipse cx="120" cy="171" rx="66" ry="9" fill="rgba(31,45,92,.10)" />
      <circle cx="34" cy="52" r="9" fill="#dbe6fd" />
      <circle cx="212" cy="70" r="6" fill="#dbe6fd" />

      {/* flap belakang folder */}
      <path d="M56 96c0-6 5-11 11-11h32l9 11h58c6 0 11 5 11 11v44H56z" fill={`url(#${backId})`} />

      {/* dokumen mengambang */}
      <g className={styles.artDoc3}>
        <rect
          x="72"
          y="46"
          width="52"
          height="66"
          rx="8"
          fill="#ffffff"
          transform="rotate(-9 98 79)"
        />
        <g transform="rotate(-9 98 79)" fill="#dbe6fd">
          <rect x="82" y="60" width="32" height="5" rx="2.5" />
          <rect x="82" y="72" width="32" height="5" rx="2.5" />
          <rect x="82" y="84" width="20" height="5" rx="2.5" />
        </g>
      </g>
      <g className={styles.artDoc2}>
        <rect x="108" y="34" width="56" height="72" rx="8" fill="#ffffff" />
        <rect x="120" y="50" width="34" height="5.5" rx="2.75" fill="#dbe6fd" />
        <rect x="120" y="63" width="34" height="5.5" rx="2.75" fill="#dbe6fd" />
        <rect x="120" y="76" width="22" height="5.5" rx="2.75" fill="#f8b95c" />
        <circle cx="153" cy="45" r="8" fill="#46be8a" />
        <path
          d="M149 45l3 3 5-6"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* kantong depan folder */}
      <path
        d="M52 108c0-6 5-11 11-11h114c6 0 11 5 11 11l-9 46c-1 6-6 10-12 10H73c-6 0-11-4-12-10z"
        fill={`url(#${frontId})`}
      />
      <path d="M52 108c0-6 5-11 11-11h114c6 0 11 5 11 11v6H52z" fill="#ffffff" fillOpacity=".14" />

      {/* kaca pembesar melayang */}
      <g className={styles.artGlass}>
        <circle
          cx="150"
          cy="120"
          r="21"
          fill="rgba(255,255,255,.55)"
          stroke="#2f55d4"
          strokeWidth="6"
        />
        <circle
          cx="150"
          cy="120"
          r="21"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2"
          strokeOpacity=".6"
        />
        <rect
          x="163"
          y="133"
          width="9"
          height="26"
          rx="4.5"
          transform="rotate(-45 167 146)"
          fill="#2f55d4"
        />
      </g>

      {/* kilau */}
      <g stroke="#4678f3" strokeWidth="2.4" strokeLinecap="round">
        <path className={styles.artSpark} d="M40 104v10M35 109h10" opacity=".5" />
        <path
          className={`${styles.artSpark} ${styles.artSpark2}`}
          d="M196 40v10M191 45h10"
          opacity=".5"
        />
        <path
          className={`${styles.artSpark} ${styles.artSpark3}`}
          d="M204 118v9M200 122h9"
          opacity=".5"
        />
      </g>
    </svg>
  )
}

export default EmptyIllustration
